import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SolutionsPage = () => {
  const solutions = [
    {
      label: 'DISPOSITIFS MÉDICAUX STÉRILES',
      title: 'Solutions de stérilisation et consommables',
      description: 'A.D.F Biomedical fournit une gamme complète de dispositifs médicaux stériles essentiels pour garantir la sécurité des patients et du personnel soignant. Nos produits répondent aux normes de stérilisation les plus strictes.',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/a3ac430ddfb73eb5838677ed91bd8499.webp',
      equipments: [
        'Gants stériles et non stériles',
        'Seringues et aiguilles à usage unique',
        'Compresses et pansements stériles',
        'Kits chirurgicaux stériles',
        'Champs opératoires',
        'Masques chirurgicaux',
      ],
      applications: 'Blocs opératoires, services de chirurgie, urgences, soins intensifs, cabinets médicaux',
    },
    {
      label: 'ÉQUIPEMENTS HOSPITALIERS',
      title: 'Matériel médical pour établissements de santé',
      description: 'Nous proposons une sélection rigoureuse d\'équipements hospitaliers destinés à équiper les établissements de santé publics et privés. Chaque produit est choisi pour sa durabilité et sa conformité aux standards internationaux.',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/92714e932559a34cbb3515489f3856ab.jpeg',
      equipments: [
        'Lits médicalisés électriques',
        'Chariots de soins et d\'urgence',
        'Tables d\'examen et d\'opération',
        'Mobilier hospitalier',
        'Équipements de stérilisation',
        'Matériel de réanimation',
      ],
      applications: 'Hôpitaux publics, cliniques privées, maisons de retraite, centres de rééducation',
    },
    {
      label: 'CONSOMMABLES MÉDICAUX',
      title: 'Produits consommables essentiels',
      description: 'Notre catalogue de consommables médicaux couvre l\'ensemble des besoins quotidiens des professionnels de santé. Nous garantissons une disponibilité constante et une qualité irréprochable.',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/9a3576d75defc2c5b11ff06d4f994ef4.jpeg',
      equipments: [
        'Équipements de protection individuelle (EPI)',
        'Blouses et surblouses',
        'Tubes de prélèvement sanguin',
        'Poches de perfusion',
        'Cathéters et sondes',
        'Matériel de diagnostic rapide',
      ],
      applications: 'Laboratoires d\'analyses, services de soins, pharmacies hospitalières, centres de prélèvement',
    },
    {
      label: 'SOLUTIONS SUR MESURE',
      title: 'Accompagnement personnalisé',
      description: 'A.D.F Biomedical propose un service d\'accompagnement sur mesure pour répondre aux besoins spécifiques de chaque établissement. Notre équipe d\'experts vous conseille dans le choix des équipements les plus adaptés.',
      image: 'https://public.readdy.ai/ai/img_res/d7ef6558b3cbe28f7f21d923f059c3d4.jpg',
      equipments: [
        'Audit des besoins en équipements',
        'Recommandations personnalisées',
        'Formation du personnel médical',
        'Installation et mise en service',
        'Maintenance préventive et curative',
        'Gestion des stocks et approvisionnement',
      ],
      applications: 'Projets d\'équipement hospitalier, renouvellement de matériel, ouverture de nouveaux services',
    },
  ];

  const qualityCards = [
    {
      icon: 'ri-shield-check-line',
      title: 'Certifications internationales',
      description: 'Tous nos dispositifs médicaux sont certifiés CE et conformes aux normes ISO. Nous travaillons exclusivement avec des fabricants reconnus mondialement.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Support technique',
      description: 'Notre équipe technique assure l\'installation, la formation et la maintenance de tous les équipements fournis. Un service après-vente réactif est disponible 24/7.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Livraison rapide',
      description: 'Nous garantissons des délais de livraison courts sur l\'ensemble du territoire algérien grâce à notre réseau logistique optimisé et nos stocks permanents.',
    },
  ];

  const stats = [
    { number: '+10', label: 'Années d\'expérience' },
    { number: '+40', label: 'Années d\'expertise de l\'équipe' },
    { number: '100%', label: 'Produits certifiés' },
    { number: '24/7', label: 'Support disponible' },
  ];

  return (
    <>
      <header>
        <h1 className="sr-only">Nos solutions médicales - SARL ADF Biomédical - Équipements hospitaliers et dispositifs médicaux en Algérie</h1>
      </header>
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative bg-[#1A1A1A] pt-32 pb-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
                Nos solutions
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto">
                Des équipements médicaux adaptés à chaque spécialité
              </p>
            </motion.div>
          </div>
        </section>

        {/* Intro Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3 className="text-4xl font-bold text-[#1A1A1A] mb-6">
                Solutions médicales complètes pour professionnels de santé
              </h3>
              <p className="text-lg text-[#4A4A4A] leading-relaxed">
                A.D.F Biomedical propose une gamme étendue de dispositifs médicaux couvrant l'ensemble des besoins des établissements de santé publics et privés en Algérie. Chaque solution est sélectionnée pour sa qualité, sa fiabilité et sa conformité aux normes internationales.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Solutions Blocks */}
        {solutions.map((solution, index) => (
          <section
            key={index}
            className={`py-20 ${index % 2 === 0 ? 'bg-[#F8F8F8]' : 'bg-white'}`}
          >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8 }}
                  className={index % 2 === 1 ? 'lg:order-2' : ''}
                >
                  <div className="w-full h-[500px]">
                    <img
                      src={solution.image}
                      alt={solution.title}
                      className="w-full h-full object-cover rounded-lg shadow-lg"
                    />
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8 }}
                  className={index % 2 === 1 ? 'lg:order-1' : ''}
                >
                  <div className="inline-block px-4 py-2 bg-[#E31B23] text-white text-xs font-semibold tracking-wider mb-4 rounded">
                    {solution.label}
                  </div>
                  <h4 className="text-3xl font-bold text-[#1A1A1A] mb-4">{solution.title}</h4>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-8">
                    {solution.description}
                  </p>

                  <div className="mb-8">
                    <h5 className="text-lg font-semibold text-[#1A1A1A] mb-4">Équipements disponibles :</h5>
                    <ul className="space-y-3">
                      {solution.equipments.map((equipment, idx) => (
                        <li key={idx} className="flex items-start">
                          <i className="ri-check-line text-[#E31B23] text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                          <span className="text-base text-[#4A4A4A]">{equipment}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-[#F0F0F0] p-6 rounded-lg mb-8">
                    <h5 className="text-base font-semibold text-[#1A1A1A] mb-2">Applications :</h5>
                    <p className="text-sm text-[#4A4A4A]">{solution.applications}</p>
                  </div>

                  <Link
                    to="/contact"
                    className="inline-block px-8 py-3 bg-[#E31B23] text-white rounded-lg font-medium hover:bg-[#C41820] transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Demander des informations
                  </Link>
                </motion.div>
              </div>
            </div>
          </section>
        ))}

        {/* Quality Guarantee Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h3 className="text-4xl font-bold text-[#1A1A1A] mb-4">Garantie de qualité</h3>
              <p className="text-lg text-[#4A4A4A]">
                Tous nos équipements répondent aux standards les plus élevés
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {qualityCards.map((card, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-[#F8F8F8] rounded-lg p-8 hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-[#E31B23]/10 rounded-full">
                    <i className={`${card.icon} text-4xl text-[#E31B23]`}></i>
                  </div>
                  <h4 className="text-xl font-semibold text-[#1A1A1A] mb-3 text-center">{card.title}</h4>
                  <p className="text-base text-[#4A4A4A] text-center leading-relaxed">{card.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-[#F8F8F8]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="text-center"
                >
                  <div className="text-5xl font-bold text-[#E31B23] mb-2">{stat.number}</div>
                  <div className="text-sm text-[#4A4A4A] font-medium">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6">
                Besoin d'une solution personnalisée ?
              </h3>
              <p className="text-xl text-[#4A4A4A] mb-10">
                Notre équipe d'experts est à votre disposition pour vous conseiller
              </p>
              <Link
                to="/contact"
                className="inline-block px-12 py-4 bg-[#E31B23] text-white rounded-lg font-semibold text-lg hover:bg-[#C41820] transition-all duration-300 shadow-lg hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Contactez nos experts
              </Link>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default SolutionsPage;
